export interface ErrorMessage {
  error: string
}

/** MiaaFwエラーオブジェクト */
export interface MiiaFwError {
  /** エラーメッセージ */
  message: string
  /**
   * エラー名
   * @remarks 詳細な定義は不明。MiiaFW実装内で定義が見つからなかったため、認証基盤で定義されている文字列と推測される。
   * 既存実装のハンドリング処理で参照箇所があったため、型エラーにならないように定義。
   */
  name?: string
}

/**
 * MiiaFwError型ガード関数
 * @param obj 判定対象オブジェクト
 * @returns 型ガード判定結果
 */
export function isMiiaFwError(obj: unknown): obj is MiiaFwError {
  return (
    obj != null &&
    typeof obj === 'object' &&
    'message' in obj &&
    typeof (obj as MiiaFwError).message === 'string'
  )
}
